import {useGetCoreFeatureToggles} from 'api/core';
import React, {ReactNode} from 'react';

import {FeatureToggleContext} from './FeatureToggleContext';
import {featureToggleAggregateMap} from './utils';

type Props = {
  children: ReactNode;
};

export const FeatureToggleProvider = ({children}: Props) => {
  const {data: featuresData, isLoading} = useGetCoreFeatureToggles();

  const provideValue = React.useMemo(
    () => ({
      features: (featuresData ?? []).map(featureToggleAggregateMap),
      isLoading,
    }),
    [featuresData, isLoading]
  );

  return <FeatureToggleContext.Provider value={provideValue}>{children}</FeatureToggleContext.Provider>;
};
